module.exports = __webpack_public_path__ + "static/media/EU.bcf6fb3d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/EU.svg
// module id = 249
// module chunks = 0